// 发布前端会整目录替换 dist（rsync --delete），发布前打开的页面仍拿着旧 app.js，
// 首次进入未加载过的页面时会请求已被删除的分包，路由跳转在半路失败（标题已改、页面不动）。
// 遇到这种失败就整页加载目标地址，换上新版前端。

const RELOAD_KEY = 'gutdb-stale-chunk-reload-at'
// 刚刷新过又失败说明不是旧版本问题（如网络断开），这段时间内不再刷新，避免死循环。
const RELOAD_COOLDOWN_MS = 10_000

export function isChunkLoadError(error) {
  if (!error) return false
  return error.name === 'ChunkLoadError'
    || error.code === 'CSS_CHUNK_LOAD_FAILED'
    || /Loading (CSS )?chunk \S+ failed/.test(error.message || '')
}

export function reloadForStaleChunk(error, to, win = window, now = Date.now) {
  if (!isChunkLoadError(error)) return false
  let lastReloadAt = 0
  try { lastReloadAt = Number(win.sessionStorage.getItem(RELOAD_KEY)) || 0 } catch { /* 受限浏览器环境按未刷新处理 */ }
  if (now() - lastReloadAt < RELOAD_COOLDOWN_MS) return false
  try { win.sessionStorage.setItem(RELOAD_KEY, String(now())) } catch { /* 写不进时仍刷新一次 */ }
  // hash 路由下只改 hash 不会重新加载页面：先把地址换成目标页，再整页刷新。
  win.history.replaceState(win.history.state, '', `#${to?.fullPath || '/'}`)
  win.location.reload()
  return true
}
